module.exports = __webpack_public_path__ + "img/1.38d62c1.svg";